import {Injectable} from '@angular/core';
import Season from '@app/core/models/enumerations/season.model';
import {GET_QUADRANT_REPORT_SEASONS} from '@app/core/resolvers/queries/season.query';

import {AppSyncHelper} from '@coach-bot/data-access/core';
import {GetLearningRateQuadrantReportSeasonsQuery} from 'app/API.service';
import {ObjectMapper} from 'json-object-mapper';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SeasonService {
  constructor(private readonly appSyncHelper: AppSyncHelper) {}

  public getLearningRateQuadrantReportSeasons(): Observable<Season[]> {
    return this.appSyncHelper
      .query<GetLearningRateQuadrantReportSeasonsQuery, string>(GET_QUADRANT_REPORT_SEASONS, null)
      .pipe(map(value => ObjectMapper.deserializeArray(Season, value.getLearningRateQuadrantReportSeasons)));
  }
}
